import { render, staticRenderFns } from "./MyShiftDetailsView.vue?vue&type=template&id=b6237332&scoped=true&"
import script from "./MyShiftDetailsView.vue?vue&type=script&lang=js&"
export * from "./MyShiftDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./MyShiftDetailsView.vue?vue&type=style&index=0&id=b6237332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6237332",
  null
  
)

export default component.exports